// Function to initialize header behavior on scroll
const initHeader = () => {
  const mobileHeader = document.querySelector('.mobile-header');
  const wrapper = document.querySelector('.wrapper');
  let announcementBarHeight = null;

  if (!mobileHeader) {
    return;
  }

  const hidePos = 200;
  let prevScrollYPos = 0;

  // Function to handle header visibility based on scroll position
  const headerScrollHandler = () => {
    if (wrapper.scrollTop === 0) {
      mobileHeader.classList.remove('hide');
    } else if (wrapper.scrollTop > hidePos) {
      if (wrapper.scrollTop < prevScrollYPos) {
        mobileHeader.classList.remove('hide');
      } else {
        mobileHeader.classList.add('hide');
      }
    }

    prevScrollYPos = wrapper.scrollTop;
  };

  headerScrollHandler();

  wrapper.addEventListener('scroll', headerScrollHandler);

  const mutationObserverOptions = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
    attributeOldValue: true,
    characterDataOldValue: true
  };

  const announcementBarRenderObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.id == 'announcement-bar-root') {
        announcementBarHeight = Math.floor(
          document.querySelector('#announcement-bar-root').getBoundingClientRect().height
        );
        wrapper.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
      }
    });
  });

  announcementBarRenderObserver.observe(document.body, mutationObserverOptions);
};

export { initHeader };
